import ExcelPointRewardUpload from '@/component/excel/ExcelPointRewardUpload';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import Header from '@/component/Header';
export default function ExcelUploadPointReward() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="사용자 포인트 리워드 수동 지급" />
          <Divider />
          <CardContent>
            <ExcelPointRewardUpload />
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
